<script src="https://www.google.com/recaptcha/api.js" async defer></script>

<script>
import CountriesApi from "@/services/countries-api";
import PartnerApi from "@/services/partner-api";
import RequestPartnerZone from "@/router/views/zone/request-partner-zone-component";


export default {

    components:{RequestPartnerZone},
    
    data() {
        return {

        citiesList:[],
        countriesList:[],
        selectedCountry:null,
        selectedCity:null,

        sectorOptions: [
            { code: 1, sector: 'Boulangerie' },
            { code: 0, sector: 'Pharmacie' },
        ],
        dayOffOptions: [
            { code: 1, day: 'Lundi' },
            { code: 2, day: 'Mardi' },
            { code: 3, day: 'Mercredi' },
            { code: 4, day: 'Jeudi' },
            { code: 5, day: 'Vendredi' },
            { code: 6, day: 'Samedi' },
            { code: 7, day: 'Dimanche' },
        ],

        refreshMapKey: 0,
        position: {latitude:36.79466, longitude:10.17963},
            
        membershipApplication:{
            selectedActivity: null,
            selectedDayOff: null,
           
            latitude:null,
            longitude:null,
        }
        }
    },
    computed: {
        recaptchaSiteKey() {
            return this.$store.state.recaptchaSiteKey;
        },

        isValidForm(){
            return this.membershipApplication.name == null || this.membershipApplication.name == '' ||
            this.membershipApplication.companyName == null || this.membershipApplication.companyName == '' ||
            this.membershipApplication.phone1 == null || this.membershipApplication.phone1 == '' ||
            this.membershipApplication.address == null || this.membershipApplication.address == '' ||
            this.membershipApplication.codePostal == null || this.membershipApplication.codePostal == '' ||
            this.selectedCountry == null || this.selectedCountry.id == null ||
            this.selectedCity == null || this.selectedCity.id == null ||
            this.membershipApplication.latitude == null || this.membershipApplication.longitude == null
            || this.membershipApplication.selectedActivity == null  || this.membershipApplication.selectedDayOff == null
            || isNaN(this.membershipApplication.codePostal)
        }
    
    },


  mounted() {
    this.loadRecaptchaScript();
    this.getCountries()
  },

  watch: {
        selectedCountry: function(){
          if(this.selectedCountry != null){
            this.getCities()
          }else{
              this.citiesList=[]
          }
        },

        selectedCity: function(){
            if(this.selectedCity != null){
              this.membershipApplication.codePostal = this.selectedCity.codePostal

              if (this.selectedCity.latitude && this.selectedCity.longitude) {
                this.position.latitude = this.selectedCity.latitude
                this.position.longitude = this.selectedCity.longitude

                this.membershipApplication.latitude = null;
                this.membershipApplication.longitude = null
              }
              

              this.refreshMapKey++;
            }
          },

    },

  methods:{

    updatePosition(position) {
        if(position == null){
            return
        }
        this.membershipApplication.latitude = position.latitude
        this.membershipApplication.longitude = position.longitude
    },

    requestAddPartner() {

        grecaptcha.ready(() => {
        grecaptcha.execute(this.recaptchaSiteKey, { action: 'submit' })
          .then(token => {
                const partner = {
                    id: this.membershipApplication.id,
                    ownerName: this.membershipApplication.name,
                    countryId:  this.selectedCountry == null ? null :  this.selectedCountry.id,
                    cityId: this.selectedCity == null ? null :  this.selectedCity.id,
                    codePostal: this.membershipApplication.codePostal,
                    name: this.membershipApplication.companyName,
                    sector: this.membershipApplication == null || this.membershipApplication.selectedActivity == null ? null : this.membershipApplication.selectedActivity.code,
                    phone1: this.membershipApplication.phone1,
                    phone2: this.membershipApplication.phone2,
                    adresse: this.membershipApplication.address,
                    dayOff: this.membershipApplication == null || this.membershipApplication.selectedDayOff == null ? null : this.membershipApplication.selectedDayOff.code,
                    gps: this.membershipApplication == null ||  this.membershipApplication.latitude == null || this.membershipApplication.longitude == null ? 
                            null : 
                            this.membershipApplication.latitude + ";" + this.membershipApplication.longitude,
                    token : token,

                };


                PartnerApi.requestAddPartner(partner).then(result => {
                    if (result) {

                        setTimeout(() => {
                            this.$router.push({ name: "default" });
                        }, 3000);

                        //Vue.prototype.$snotify.simple('Votre demande a été bien evoyée')
                       // this.$router.push({ path: "/", });
                    }
                }); 
            });
        });

        }, 

    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
            this.selectedCountry = this.countriesList[0]
        })
     },
    getCities(){
        if(this.selectedCountry == null || this.selectedCountry.id  == null){
            this.citiesList=[]
            return;
        }
       CountriesApi.getCities(this.selectedCountry.id).then(
          result => {
            this.citiesList = result
        })
     },

    loadRecaptchaScript() {

    const recaptchaSiteKey = this.recaptchaSiteKey

    grecaptcha.ready(function() {
        grecaptcha.render('recaptcha-container', {
        'sitekey': recaptchaSiteKey,
        'badge': 'inline',
        'size': 'invisible'
    });
    });

    },  

  }

    
}
</script>

<template>
<div class="  ">




<div class="card h-100 w-100" style="border: 1px solid rgb(221, 221, 221); border-radius:8px;">
    <div class="card-body">


        <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">

                <!-- Name -->
                <div class="font-size-16 pt-2 pb-2 text-dark"> {{$t('membershipApplication.label.name')}} <span class="text-danger">*</span> </div>
                <b-form-group   class=" text-dark font-weight-bold"   >
                    <b-input-group   >
                        <b-form-input class="font-size-16 text-dark font-weight-bold" :placeholder="$t('membershipApplication.input.name')"   
                        v-model="membershipApplication.name" ></b-form-input>                              
                    </b-input-group>
                </b-form-group>
            </div>
            

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">

                <!-- Company Name -->
                <div class="font-size-16 pt-2 pb-2 text-dark"> {{$t('membershipApplication.label.companyName')}} <span class="text-danger">*</span> </div>
                <b-form-group   class="font-weight-bold text-dark "   >
                    <b-input-group   >
                        <b-form-input class="font-size-16 text-dark font-weight-bold"  :placeholder="$t('membershipApplication.input.companyName')"   
                        v-model="membershipApplication.companyName" ></b-form-input>                              
                    </b-input-group>
                </b-form-group>

            </div>

        </div>



        <div class="row">

            <!-- Secteur d'activité  -->
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                <div class="font-size-16 text-dark pt-2 pb-2 "> {{$t('membershipApplication.label.sectorActivity')}} <span class="text-danger">*</span> </div>
                <b-form-group  label-for="">
                    <v-select class="style-vselect-big text-dark" style="font-size:1.2em;" 
                            :options="sectorOptions" 
                            :placeholder="$t('lists.sector.label')" 
                            label="sector" v-model="membershipApplication.selectedActivity">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">

                <!-- Jour de repos -->
                <div class="font-size-16 pt-2 pb-2 text-dark"> {{$t('membershipApplication.label.dayOff')}} <span class="text-danger">*</span> </div>
                <b-form-group  label-for="">
                    <v-select class="style-vselect-big text-dark" style="font-size:1.2em;" 
                            :options="dayOffOptions" 
                            :placeholder="$t('lists.day.label')" 
                            label="day" v-model="membershipApplication.selectedDayOff">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>

        </div>



        <div class="row">

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">

                <!-- Phone 1 -->
                <div class="font-size-16 pt-2 pb-2 text-dark"> {{$t('membershipApplication.label.phone1')}} <span class="text-danger">*</span> </div>
                <b-form-group   class="font-weight-bold text-dark"   >
                    <b-input-group   >
                        <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('membershipApplication.input.phone1')"   
                        v-model="membershipApplication.phone1" ></b-form-input>                              
                    </b-input-group>
                </b-form-group>

            </div>

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">

                <!-- Phone 2 -->
                <div class="font-size-16 pt-2 pb-2 text-dark"> {{$t('membershipApplication.label.phone2')}} <span class="text-danger"></span> </div>
                <b-form-group   class="font-weight-bold"   >
                    <b-input-group   >
                        <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('membershipApplication.input.phone2')"   
                        v-model="membershipApplication.phone2" ></b-form-input>                              
                    </b-input-group>
                </b-form-group>

            </div>

        </div>


        <div class="row mt-4">
           
            <!-- Country -->
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                <div  class="font-size-16 pt-2 pb-2 text-dark"> {{$t('membershipApplication.label.country')}} <span class="text-danger">*</span> </div>
                    <b-form-group  label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="countriesList" :placeholder="$t('membershipApplication.input.country')"  label="name" v-model="selectedCountry" disabled>
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
            </div>

            <div  class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">

            <!-- City -->
            <div  class="font-size-16 pt-2 pb-2 text-dark"> {{$t('membershipApplication.label.city')}} <span class="text-danger">*</span> </div>
            <b-form-group  label-for="">
                <v-select class="style-vselect-big text-dark font-size-16"  :options="citiesList" :placeholder="$t('membershipApplication.input.city')" label="name" v-model="selectedCity">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>

            </div>


        </div>




        <div class="row">

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                <!-- Address -->
                <div class="font-size-16 pt-2 pb-2 text-dark "> {{$t('membershipApplication.label.address')}} <span class="text-danger">*</span> </div>
                <b-form-group   class="font-weight-bold font-size-14"   >
                    <b-input-group   >
                        <b-form-input class="text-dark font-size-16 font-weight-bold" :placeholder="$t('membershipApplication.input.address')"   
                        v-model="membershipApplication.address" ></b-form-input>                              
                    </b-input-group>
                </b-form-group>
            </div>

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">
                <!-- Postal Code -->
                <div class="font-size-16 pt-2 pb-2 text-dark"> {{$t('membershipApplication.label.postalCode')}} <span class="text-danger">*</span> </div>
                <b-form-group   class="font-weight-bold font-size-14"   >
                    <b-input-group   >
                        <b-form-input type="number" class="font-size-16 text-dark font-weight-bold" :placeholder="$t('membershipApplication.input.postalCode')"   
                        v-model="membershipApplication.codePostal" ></b-form-input>                              
                    </b-input-group>
                </b-form-group>
            </div>

        </div>





        <div class="row mt-5">









       

                

                

                


            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >

                <div class="row mb-1">
                    <div class="col-md-8 col-12">
                        <div class="font-size-16 pt-2 pb-2 font-weight-bold text-dark ">{{ $t('ourPartner.selectePosition') }}<span class="text-danger">*</span> </div>
                    </div>
                    <div class="col-md-4 col-12 d-flex justify-content-between">
                        <b-form-input class="bg-light mr-2" :placeholder="$t('membershipApplication.input.latitude')"   
                        v-model="membershipApplication.latitude"
                        disabled ></b-form-input>                              
                        <b-form-input class="bg-light" :placeholder="$t('membershipApplication.input.longitude')"   
                        v-model="membershipApplication.longitude"
                        disabled ></b-form-input>                              
                    </div>
                </div>


                <RequestPartnerZone :key="refreshMapKey" @position-selected="updatePosition" :companyName="membershipApplication.companyName" :longitude="position.longitude" :latitude="position.latitude"/>
            
               
            
            </div>

        </div>




      

<div class="mt-5 mb-3 ">
    <span class="text-danger font-size-16">*</span>
    <span class=" ml-2 text-secondary font-weight-bold font-size-14">{{$t('ourPartner.requiredInformation')}}</span>
</div>



<!-- <div class="form-group  mt-2" >
    <b-form-checkbox value="1" unchecked-value="0" v-model="membershipApplication.condition" class="custom-checkbox custom-checkbox-success mb-0 mt-0">
    <span class="text-secondary font-size-14">{{$t('ourPartner.acceptPriorityDistribution')}}</span>
    </b-form-checkbox>
</div> -->

<div class="mt-3 mb-3">

    <!-- :disabled="isValidForm" -->
    <b-button variant="primary"  style="padding: 10px 26px; " class="font-weight-bold w-100 font-size-18" @click="requestAddPartner()" >
    <div class="font-weight-normal font-size-12">Devenir Partenaire </div>
        Envoyer la demande
    </b-button>   

</div>



<div class="row mt-5 mb-3">
    <div class="col-12 text-right">
        <div  id="recaptcha-container"/>
    </div>
</div>


</div>
</div>

</div>
</template>

<style >
#recaptcha-container {
  position: relative;
  width: 100%; 
  height: 100%;
  justify-content: center; 
  align-items: center;
  opacity: 0.3;

}

#recaptcha-container .grecaptcha-badge {
  display: block !important;
  position: relative;
  margin: auto;
}

</style>

<style scoped>
  .style-vselect-big{
    background-color:  white;
  }
</style>